import { Column } from 'react-table';

import { OdpMonitoringListResult } from 'api';
import { formatDate } from 'utils';
import { CheckIcon, ViewDetailsButton } from 'components';
import { SelectionCell } from '../common';
import {
  getOdpMonitoringReasonName,
  getOdpMonitoringResultName,
  getOdpMonitoringStageName,
} from './common';

export const columns: Column<OdpMonitoringListResult>[] = [
  {
    Header: ' ',
    id: 'selection',
    width: '50px',
    disableSortBy: true,
    Cell: ({ row }) => (
      <SelectionCell
        row={row}
        isSelectable={(data) => !data.isDeleted}
        disabledMessage="Deleted monitoring records cannot be selected"
      />
    ),
  },
  {
    Header: 'Date of monitoring',
    accessor: 'date',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Reason for monitoring',
    accessor: 'reason',
    width: 'auto',
    Cell: ({ value }) => <>{getOdpMonitoringReasonName(value)}</>,
  },
  {
    Header: 'Monitoring result',
    accessor: 'result',
    width: 'auto',
    Cell: ({ value }) => <>{getOdpMonitoringResultName(value)}</>,
  },
  {
    Header: 'Monitoring stage',
    accessor: 'stage',
    width: 'auto',
    Cell: ({ value }) => <>{getOdpMonitoringStageName(value)}</>,
  },
  {
    Header: 'Follow-up',
    accessor: 'hasFollowUp',
    width: '100px',
    Cell: CheckIcon,
  },
  {
    Header: 'Details',
    id: 'actions',
    width: '50px',
    Cell: ({ row }) => <ViewDetailsButton to={row.original.id} />,
  },
];
